var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-bg-white ui-px-6 ui-py-4",staticStyle:{"border-radius":"8px","box-shadow":"0 4px 16px rgba(34, 34, 34, 0.02)"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }